let currentAudio: HTMLAudioElement | null = null;
let currentUrl: string | null = null;
let currentId: string | null = null;

let listeners: ((id: string | null, isPlaying: boolean) => void)[] = [];

export const subscribeAudio = (
  cb: (id: string | null, isPlaying: boolean) => void
) => {
  listeners.push(cb);
  return () => {
    listeners = listeners.filter((l) => l !== cb);
  };
};

const notify = (isPlaying: boolean) => {
  listeners.forEach((cb) => cb(currentId, isPlaying));
};

type AudioCallbacks = {
  id: string;
  onLoading?: () => void;
};

export const playGlobalAudio = async (
  audioBlob: Blob,
  { id, onLoading }: AudioCallbacks
) => {
  try {
    if (currentAudio) {
      currentAudio.pause();
      cleanup();
    }

    currentId = id;
    notify(false);

    onLoading?.();

    const audioUrl = URL.createObjectURL(audioBlob);
    currentUrl = audioUrl;

    const audio = new Audio(audioUrl);
    currentAudio = audio;

    audio.onplaying = () => {
      notify(true);
    };

    audio.onended = () => {
      cleanup();
      notify(false);
    };

    audio.onerror = () => {
      cleanup();
      notify(false);
    };

    await audio.play();
  } catch {
    notify(false);
  }
};

export const toggleGlobalAudio = (id: string) => {
  if (!currentAudio || currentId !== id) return;

  if (currentAudio.paused) {
    currentAudio.play();
    notify(true);
  } else {
    currentAudio.pause();
    notify(false);
  }
};

const cleanup = () => {
  if (currentUrl) {
    URL.revokeObjectURL(currentUrl);
    currentUrl = null;
  }
  currentAudio = null;
  currentId = null;
};

export const stopGlobalAudio = () => {
  if (currentAudio) {
    currentAudio.pause();
  }
  cleanup();
  notify(false);
};